import { render, staticRenderFns } from "./EditingAtractionsUniqnes.vue?vue&type=template&id=058d6452&scoped=true&"
import script from "./EditingAtractionsUniqnes.vue?vue&type=script&lang=js&"
export * from "./EditingAtractionsUniqnes.vue?vue&type=script&lang=js&"
import style0 from "./EditingAtractionsUniqnes.vue?vue&type=style&index=0&id=058d6452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d6452",
  null
  
)

export default component.exports